import {Helmet} from "react-helmet";

const SITE = "https://leaderautoship.com";

// One place for each page's title, description, canonical and share tags.
const Seo = ({title, description, path, noindex, jsonLd}) => <Helmet>
    <title>{title}</title>
    <meta name="description" content={description}/>
    {path && <link rel="canonical" href={SITE + path}/>}
    {noindex && <meta name="robots" content="noindex"/>}
    <meta property="og:type" content="website"/>
    <meta property="og:site_name" content="Leader Auto Ship"/>
    <meta property="og:title" content={title}/>
    <meta property="og:description" content={description}/>
    {path && <meta property="og:url" content={SITE + path}/>}
    <meta property="og:image" content={SITE + "/images/og-image.jpg"}/>
    {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
</Helmet>;

export default Seo;
